import { createContext, useContext, useEffect, useState } from "react";

export const MobileContext = createContext();

const MobileContextProvider = ({ children }) => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResizer = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResizer);

    return () => window.removeEventListener("resize", handleResizer);
  }, []);
  
  const isMobileScreen =  width < 768;

  const values = {
    isMobileScreen
  }

  return <MobileContext.Provider value={values}>{children}</MobileContext.Provider>;
};


export const useMobileContext = () => {
  const context = useContext(MobileContext);
  if (context === undefined) {
    throw new Error("useMobileContext must be used within a MobileContextProvider");
  }
  return context;
};

export default MobileContextProvider;
